import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'

export const pathKey = 'standardAnalysis' satisfies PathKey

export type ScrollHash = string // `${Brand['id']}`

// 回答行は `${Question['question_id']}-${AnswerOption['option']}`、
// 顧客属性行は CustomerAttribute['id'] そのもの。
export type DisplayRowId = string
